import { Directive, Inject, Optional, ElementRef, HostListener, DOCUMENT } from '@angular/core';

import { NgxMaskDirective, NgxMaskService  } from 'ngx-mask';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[pcgZipCode]',
    providers: [NgxMaskService],
    standalone: false
})
export class ZipCodeDirective extends NgxMaskDirective {
	constructor(@Inject(DOCUMENT) document: any, maskService: NgxMaskService,
		private elRef: ElementRef, @Optional() private control: NgControl) {
		super();
		this.maskExpression = '00000';
		this.dropSpecialCharacters = false;
	}

	@HostListener('keyup')
	keyEvent() {
		if (this.control) {
			this.control?.control?.setValue(this.elRef.nativeElement.value);
		}
	}

	@HostListener('change')
	changeEvent() {
		if (this.control) {
			this.control?.control?.setValue(this.elRef.nativeElement.value);
		}
	}
}
